import { h, Component } from 'preact';
import { BaseField } from '../BaseField';

import { bind, memoize, debounce } from 'decko';
import Radio from 'preact-material-components/Radio';
import FormField from 'preact-material-components/FormField';

import { IRadioButtonListProps, IRadioButtonListState } from './IRadioButtonList';

//let style = require('./style.css');

export class RadioButtonList extends BaseField<IRadioButtonListProps, IRadioButtonListState> {

    constructor(props: IRadioButtonListProps, ctx) {
        super(props, ctx);
        this.setState({
            value : props.value
        })
    }

    @bind
    public onChange(value) {
        this.setState({ value: value });
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        var controlledRadioElements = this.props.options.map((option, i) => {
            return (
                <FormField >
                    <Radio
                        id={`radio-${this.props.name}-${i}`}
                        name={this.props.name}
                        checked={option.value == this.state.value}
                        onChange={() => { this.onChange(option.value) }}
                    />
                    <label for={`radio-${this.props.name}-${i}`}>{option.text}</label>
                </FormField>
            );
        });

        return <div class={this.props.class}><label>{this.props.label}</label><div>{controlledRadioElements}</div></div>;
    }
}




// WEBPACK FOOTER //
// ./components/forms/fields/radioButtonList/RadioButtonList.tsx